export default __webpack_public_path__ + "img/equipments-specialties-banner0.asset.95891aa8.jpg";